import { useEffect } from 'react';
import { useAuth } from 'hooks/useAuth/useAuth';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';

const Logout = () => {
  const { signout } = useAuth();
  let history = useHistory();

  useEffect(() => {
    signout();
    history.push(ROUTES.LOGIN);
  }, [history, signout]);

  return null;
};

export default Logout;
